import React, { useEffect, useState } from "react";
import "./RegistrationForm.css";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const UserProfile = ({ API_URL }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [designation, setDesignation] = useState("");
    const [preferredLanguage, setPreferredLanguage] = useState("English");

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    useEffect(() => {
        const storedFirstName = localStorage.getItem("firstName") || "";
        const storedLastName = localStorage.getItem("lastName") || "";
        const storedDesignation = localStorage.getItem("designation") || "";
        const storedNativeLanguage = localStorage.getItem("language");

        setFirstName(storedFirstName);
        setLastName(storedLastName);
        setDesignation(storedDesignation);

        // If nativeLanguage is null/empty, default to English
        const lang = storedNativeLanguage && storedNativeLanguage.trim().length > 0
            ? storedNativeLanguage.trim()
            : "English";
        setPreferredLanguage(lang);
    }, []);

    const closeErrorPopup = () => {
        setErrorMessage(null);
        setIsLoading(false);
    };

    const closeSuccessPopup = () => {
        setShowSuccessPopup(false);
        // navigate(-1); // optional: go back
    };

    const updateUser = async (e) => {
        e.preventDefault();

        const fn = (firstName ?? "").trim();
        const ln = (lastName ?? "").trim();
        const des = (designation ?? "").trim();
        const lang = (preferredLanguage ?? "").trim();

        if (!fn || !ln || !des || !lang) {
            setErrorMessage("Please fill all fields.");
            return;
        }

        const email = localStorage.getItem("email")
        setIsLoading(true);
        setErrorMessage(null);

        const request = {
            email: email,
            firstName: fn,
            lastName: ln,
            designation: des,
            nativeLanguage: lang,
        };

        try {
            const jwt = localStorage.getItem("jwtToken");

            await axios.put(`${API_URL}/user`, request, {
                headers: {
                    "Content-Type": "application/json",
                    ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
                },
            });

            localStorage.setItem("firstName", fn);
            localStorage.setItem("lastName", ln);
            localStorage.setItem("designation", des);
            localStorage.setItem("language", lang);

            setShowSuccessPopup(true);
        } catch (error) {
            if (error.response?.data?.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage("An unexpected error occurred. Please try again later.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", marginTop: "-50px" }}>
            <Navbar />

            <main
                style={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "#f9f9f9",
                }}
            >
                <div
                    className="form-container"
                    style={{
                        backgroundColor: "white",
                        color: "black",
                        width: "100%",
                        maxWidth: "800px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        padding: "20px",
                        marginBottom: "10px",
                    }}
                >
                    <form style={{ backgroundColor: "white" }} onSubmit={updateUser}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                            <h2>Update Profile</h2>
                        </div>

                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div className="form-grid">
                                <div className="form-group" style={{ alignItems: "centre", textAlign: "centre" }}>
                                    <label style={{ alignItems: "left", textAlign: "left" }}>First Name</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group" style={{ alignItems: "centre", textAlign: "centre" }}>
                                    <label style={{ alignItems: "left", textAlign: "left" }}>Last Name</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group" style={{ alignItems: "centre", textAlign: "centre" }}>
                                    <label style={{ alignItems: "left", textAlign: "left" }}>Designation</label>
                                    <input
                                        type="text"
                                        name="designation"
                                        value={designation}
                                        onChange={(e) => setDesignation(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group" style={{ alignItems: "centre", textAlign: "centre" }}>
                                    <label style={{ alignItems: "left", textAlign: "left" }}>Preferred Language</label>
                                    <select
                                        name="preferredLanguage"
                                        className="signup-select"
                                        value={preferredLanguage}
                                        onChange={(e) => setPreferredLanguage(e.target.value)}
                                        required
                                    >
                                        <option value="English">English</option>
                                        <option value="Hindi">Hindi</option>
                                        <option value="Gujarati">Gujarati</option>
                                        <option value="Marathi">Marathi</option>
                                        <option value="Bengali">Bengali</option>
                                        <option value="Telugu">Telugu</option>
                                        <option value="Tamil">Tamil</option>
                                        <option value="Kannada">Kannada</option>
                                        <option value="Malayalam">Malayalam</option>
                                        <option value="Punjabi">Punjabi</option>
                                        <option value="Urdu">Urdu</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <button
                                type="submit"
                                className="submit-button"
                                disabled={!firstName || !lastName || !designation || !preferredLanguage || isLoading}
                                style={{ width: "160px", padding: "12px 15px", marginTop: "10px", fontWeight: "bold" }}
                            >
                                {isLoading ? <div className="spinner"></div> : "Save"}
                            </button>
                        </div>

                        <br />
                        {/* <p style={{ textAlign: "center" }}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(-1);
                                }}
                                style={{ textDecoration: "underline", textUnderlineOffset: "3px" }}
                            >
                                Go back
                            </a>
                        </p> */}
                    </form>

                    {errorMessage && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Error</h3>
                                <p>{errorMessage}</p>
                                <button className="submit-popup-button" onClick={closeErrorPopup}>
                                    OK
                                </button>
                            </div>
                        </div>
                    )}

                    {showSuccessPopup && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Update Successful</h3>
                                Your profile has been updated successfully.
                                <div className="popup-buttons" style={{ marginBottom: "15px" }}>
                                    <button className="submit-popup-button" onClick={closeSuccessPopup}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default UserProfile;
